module.exports = __webpack_public_path__ + "static/media/icon_share.a9a95be7.svg";